import { useEffect, useRef } from 'react';
import { useAuth } from './AuthProvider';
import { useTenant } from '@core/tenant';
import { getAuthToken } from '@core/api';

export function useRefreshAuthProfile(): void {
  const { authState, refreshProfile } = useAuth();
  const { subdomainPrefix } = useTenant();
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    if (!authState.isAuthenticated || !getAuthToken()) return;

    ranRef.current = true;
    refreshProfile(subdomainPrefix ?? undefined).catch(() => {});
  }, [authState.isAuthenticated, refreshProfile, subdomainPrefix]);
}
